export default __webpack_public_path__ + "static/media/Shimmering_goddess_Julian_Lauren_50_x_70.8cb498ea.jpg";